<template>
  <div class="price-filter">
    <Slider
      v-model="priceRange"
      :min="min"
      :max="max"
      :lazy="false"
      class="filter"
      :format="format"
      @change="handlePriceChange"
    />
  </div>
</template>

<script>
import Slider from "@vueform/slider";
import { mapState, mapGetters } from "vuex";

export default {
  name: "PriceFilter",
  components: {
    Slider,
  },
  props: {
    values: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["change"],
  data() {
    return {
      priceRange: [
        JSON.parse(this.values[0].input).price.min,
        JSON.parse(this.values[0].input).price.max,
      ],
      price: {},
    };
  },
  computed: {
    ...mapState("collection", ["maximiumPriceRange"]),
    ...mapGetters("app", ["moneyFormat"]),
    min() {
      return this.maximiumPriceRange?.min;
    },
    max() {
      return this.maximiumPriceRange?.max;
    },
  },
  watch: {
    values(val) {
      this.min = JSON.parse(val[0].input).price.min;
      this.max = JSON.parse(val[0].input).price.max;
    },
  },
  methods: {
    handlePriceChange() {
      this.price.min = this.priceRange[0];
      this.price.max = this.priceRange[1];
      this.$emit("change", { price: this.price });
    },
    format(value) {
      const string = this.moneyFormat.replace("{{amount}}", Math.round(value));
      return string;
    },
  },
};
</script>

<style lang="scss">
@import "@vueform/slider/themes/default.scss";

.filter {
  --slider-bg: #{rgba($color-dark, 0.2)}; //
  --slider-connect-bg: #{$color-dark}; //
  --slider-height: 1px; //

  --slider-handle-border: 1px solid #{$color-dark}; //
  --slider-handle-width: 13px; //
  --slider-handle-height: 13px; //
  --slider-handle-shadow: 0; //
  --slider-handle-shadow-active: 0; //

  --slider-tooltip-font-size: 10px; //
  --slider-tooltip-line-height: 1.25rem;
  --slider-tooltip-font-weight: 400; //
  --slider-tooltip-min-width: 20px;
  --slider-tooltip-bg: transparent; //
  --slider-tooltip-color: #{$color-dark}; //
  --slider-tooltip-py: 0px; //
  --slider-tooltip-px: 0px; //
  --slider-tooltip-arrow-size: 0px; //
  --slider-tooltip-distance: 0px; //
}
</style>

<style lang="scss" scoped>
.price-filter {
  padding-top: 24px;
  padding-bottom: 12px;
}
</style>
